import { PureComponent, type ReactElement } from "react";

import { LoadingSpinner } from "widgets";

import { type Attribute } from "../../graphql.js";
import { ModalControlledOverlay } from "../core/overlays/index.js";
import {
  default as AddSampleAttributeDialog,
  type IAddSampleAttributeDialogOwnProps,
} from "./AddSampleAttributeDialog.js";

export interface IModifySampleAttributeDialogProps extends IAddSampleAttributeDialogOwnProps {
  fetchAttribute: (attribute: Attribute) => Promise<Attribute>;
}

interface IModifySampleAttributeDialogState {
  isLoadingAttribute?: boolean;
  attribute?: Attribute;
}

// component that takes the responsibiltiy of loading the attribute information to be edited
class ModifySampleAttributeDialog extends PureComponent<
  IModifySampleAttributeDialogProps,
  IModifySampleAttributeDialogState
> {
  constructor(props: IModifySampleAttributeDialogProps) {
    super(props);

    this.state = {
      isLoadingAttribute: true,
      attribute: null,
    };
  }

  componentDidMount() {
    this.setState({ isLoadingAttribute: true });
    this.props.fetchAttribute(this.props.attributeToEdit).then((attribute: Attribute) => {
      this.setState({
        attribute: attribute,
        isLoadingAttribute: false,
      });
    });
  }

  render(): ReactElement {
    return this.state.isLoadingAttribute ? (
      <LoadingSpinner inCenter />
    ) : (
      <ModalControlledOverlay close={null} isOpen={true}>
        {() => (
          <AddSampleAttributeDialog {...this.props} editingContext={true} attributeToEdit={this.state.attribute} />
        )}
      </ModalControlledOverlay>
    );
  }
}

export default ModifySampleAttributeDialog;
